import React from 'react';
import moment from 'moment';
import Icon from '../../ui/icon/icon';
import { parsedHTML } from '../../../resale/buyer/components/utils';
import formattedAmount from '../../../resale/seller/components/utils';
import Counter from '../../ui/counter/counter';
import { useTranslation } from 'react-i18next';
import './rateCard.css';

export default function RateCard({ mode = 'sale', setSelectedRates, selectedRates, rate, max_ticket, disable_plus, disable_minus, currency }) {
    const { t } = useTranslation();
    const { name, description } = rate;

    const maxRemainingTickets = React.useMemo(() => {
        if (!max_ticket) {
            return undefined;
        }
        const totalQuantityWithoutCurrentRate = Object.entries(selectedRates).reduce((acc, [key, value]) => {
            if (key !== String(rate.id)) {
                acc += value.quantity;
            }
            return acc;
        }, 0)
        const maxRemainingTotalCard = max_ticket - totalQuantityWithoutCurrentRate;
        return (rate.cart_max_quantity && maxRemainingTotalCard >= rate.cart_max_quantity) ? rate.cart_max_quantity : maxRemainingTotalCard;
    }, [max_ticket, rate, selectedRates]);

    const unavailableRate = React.useMemo(() => {
        return !rate.disable && (new Date(rate.visibility_start_date) > new Date());
    }, [rate]);

    const [showMore, setShowMore] = React.useState(unavailableRate ? false : true);
    const [ticketsToBuy, setTicketsToBuy] = React.useState(rate.preselected_quantity);
    const toggleShowMore = React.useCallback(() => setShowMore(showMore => !showMore), []);

    const hasDescription = React.useMemo(() => {
        return Boolean(rate.description);
    }, [rate]);

    const onChangeTicketsNumber = React.useCallback(( e, value ) => {
        setTicketsToBuy(parseInt(value) || 0)
        setSelectedRates({
            ...selectedRates, [rate.id]: {
                "quantity": parseInt(value) || 0,
                "price": rate.price * (value)
            }
        });
    }, [rate, selectedRates]);

    return (
        <div className={`neo-rate-card-content ${!unavailableRate ? 'neo-rate-card-content-active' : ''}`}>
            <div className={`neo-rate-content ${(rate.visibility_start_date) ? 'neo-rate-content-with-date' : ''}`}>
                <div className='neo-rate-left-container'>
                    <div className='neo-rate-title-and-group'>
                        {rate.group_name && (
                            <p className='neo-rate-group'>{rate.group_name}</p>
                        )}
                        <p className='neo-rate-title'>{name}</p>
                        <p className='neo-rate-price'>{formattedAmount(rate.price, currency)}</p>
                    </div>
                    <div className='neo-rate-card'>
                        <div className='neo-rate-infos'>
                            {
                                rate.visibility_start_date && !unavailableRate && (
                                    <div className='neo-rate-timer-and-date'>
                                        <Icon name='timer' size='small' className='neo-rate-timer-icon' />
                                        <div>
                                            {t('widget.availability')}
                                            {moment(rate.visibility_start_date).format('DD/MM/YYYY HH:mm')}
                                        </div>
                                    </div>
                                )
                            }
                            { hasDescription && (
                                <div className='neo-rate-read-more'>
                                    <div className='neo-read-more-container'>
                                        <div className={`neo-read-more-icon ${unavailableRate ? 'unavailable' : ''}`} onClick={toggleShowMore}>
                                            <Icon name='infoCircle' className={`neo-rate-info-icon ${showMore ? 'active' : ''}`} />
                                            <div className={`neo-rate-read-more ${showMore ? 'active' : ''}`}>{showMore ? t('widget.resale.event.show-less') : t('widget.resale.event.show-more')}</div>
                                        </div>
                                    </div>
                                </div>)
                            }
                        </div>
                    </div>
                </div>
                <div className='neo-rate-right-container'>
                    {
                        unavailableRate ? 
                        <div className='neo-unavailable-rate'>{t('widget.unavailable')}</div>
                    : <Counter
                            value={ticketsToBuy}
                            onChange={onChangeTicketsNumber}
                            disabledPlus={disable_plus}
                            disabledMinus={disable_minus}
                            max={mode === 'sale' ? maxRemainingTickets : rate.quantity_available }
                            ariaLabelPlus={t('widget.counter.button-plus', {rate: rate.name})}
                            ariaLabelMinus={t('widget.counter.button-minus', {rate: rate.name})}
                            ariaLabelInput={t('widget.counter.input', {rate: rate.name})}
                            ariaLabelAnnouncer={t('widget.counter.selected_quantity', {count: ticketsToBuy, rate: rate.name})}
                        />
                    }
                </div>
            </div>
            {hasDescription && (
                <div className={showMore && 'neo-rate-description'}>
                    {showMore && parsedHTML(description)}
                </div>
            )}
        </div>
    )
}
